import { Link } from "react-router-dom";
import { openCookieSettings } from "@/lib/consent";

export const Logo = ({ className = "", big = false }) => (
  <Link
    to="/"
    data-testid="logo-home-link"
    aria-label="StatementMate — UCAS personal statement feedback"
    className={`inline-flex items-center ${big ? "gap-3" : "gap-2"} ${className}`}
  >
    <svg
      viewBox="124 44 90 56"
      className={big ? "h-12 sm:h-16 w-auto" : "h-9 w-auto"}
      aria-hidden="true"
    >
      <path d="M150 78 L184 78 L180 92 Q167 98 154 92 Z" fill="#1E3A34" />
      <polygon points="167,48 206,68 167,88 128,68" fill="#C2602F" />
      <circle cx="167" cy="68" r="3" fill="#1E3A34" />
      <path d="M167 68 L206 68 L206 90" fill="none" stroke="#1E3A34" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="206" cy="91" r="3" fill="#1E3A34" />
    </svg>
    <span
      className={`font-heading font-semibold tracking-tight leading-none ${
        big ? "text-4xl sm:text-5xl" : "text-2xl"
      }`}
    >
      <span style={{ color: "#1E3A34" }}>Statement</span>
      <span style={{ color: "#C2602F" }}>Mate</span>
    </span>
  </Link>
);

export const Header = () => (
  <div className="pt-8 pb-4 px-6 flex flex-col items-center" data-testid="page-header">
    <Logo big />
  </div>
);

export const Footer = () => (
  <footer className="border-t border-border/70 mt-20">
    <div className="max-w-5xl mx-auto px-6 sm:px-8 py-10 text-sm text-ink-muted flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <Logo />
      </div>
      <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
        <Link to="/analyse" data-testid="footer-feedback-link" className="hover:text-ink transition-colors">
          Get feedback
        </Link>
        <Link to="/guides" data-testid="footer-guides-link" className="hover:text-ink transition-colors">
          Expert guides
        </Link>
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-ink transition-colors">
          Privacy Policy
        </Link>
        <Link to="/terms" data-testid="footer-terms-link" className="hover:text-ink transition-colors">
          Terms of Service
        </Link>
        <button
          type="button"
          data-testid="footer-cookie-settings"
          onClick={openCookieSettings}
          className="hover:text-ink transition-colors"
        >
          Cookie settings
        </button>
      </nav>
    </div>
    <div className="max-w-5xl mx-auto px-6 sm:px-8 pb-8 text-sm text-ink-muted">
      We give feedback — we never write your statement for you.
    </div>
  </footer>
);
